import React, { useState } from 'react';
import BackdropPopup from "../../../../lms-shared/UI/Popups/BackdropPopup/BackdropPopup";
import classes from "./VideoPopup.module.css";
import playIcon from '../../../../../assests/learning-tracking/teams/play.png'
import closeIcon from '../../../../../assests/learning-tracking/teams/close.png'
import { useSelector } from 'react-redux';

const VideoPopup = ({ setVideoPopup }) => {
    const [isPlaying, setIsPlaying] = useState(false);
    const uiData = useSelector((state) => state.general.uiData);

    const handlePlayClick = () => {
        setIsPlaying(true);
    };

    return (
        <BackdropPopup myWidth={'554px'} minHeight={'347px'}>
            <div className={classes.videoContainer} onClick={handlePlayClick}>
                <img src={closeIcon} alt="Close" className={classes.CloseIcon} onClick={() => setVideoPopup(false)} />
                {!isPlaying && (
                    <div className={classes.PlayButton}>
                        <img src={playIcon} />
                    </div>
                )}
                {isPlaying && <div className={classes.videoWrap}>
                    <video controls width="100%" height="auto" autoPlay={isPlaying}>
                       {uiData&& <source src={uiData.teamVideoUrl} type="video/mp4" />}
                    </video>
                </div>}

            </div>
        </BackdropPopup>
    );
};

export default VideoPopup;
